import H4 from 'components/H4';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import Svg from '_assets/svg';
import Wrapper from './Wrapper';

const Img = styled.img`
    width: 36px;
    height: 36px;
    margin-right: 10px;
`

const Box = styled.div`
    border-radius: 58px;    
    padding-block: 14px;
    padding-inline: 20px;
    background: #F0F3F5;
`

const A = styled.a`
    font-family: Lato;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 20px;
    /* identical to box height, or 143% */
    color: #383C42;
    cursor: pointer;
    margin-left: 30px;
    text-decoration: none;
`


const Toast = (props) => {
    const { setIsVisible, isVisible, description, undo } = props;

    useEffect(() => {
        if (isVisible) setTimeout(() => { setIsVisible(false); }, 5000);
    }, [isVisible]);

    return (
        <Wrapper isVisible={isVisible} className="d-flex justify-content-center">
            <Box className="d-flex flex-row align-items-center">
                <Img src={Svg.checklist.default} />
                <H4 className="fw-normal">{description}</H4>
                {undo && <A>UNDO</A>}
            </Box>
        </Wrapper>
    )
}



export default Toast;